export const search = {
    filterDebounceMs: 200,
    searchDebounceMs: 350,
    initialDelayBeforeSpinnerMs: 200,
    mainSearchPriorityMs: 2800,
    expirationMs: 60 * 60 * 1000,
    maxCriterionLength: 1024
};
